// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sitLoginPage {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}

.sitLoginCard {
  width: 100%;
  max-width: 860px;
  min-height: 460px;
  display: flex;
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-xl, 18px);
  background: var(--surface-card, #fff);
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
}

.sitLoginHero {
  flex: 0 0 350px;
  display: flex;
  flex-direction: column;
  padding: 40px 34px;
  background: linear-gradient(155deg, #eef6fc 0%, #dceef9 58%, #cfe8f5 100%);
  color: var(--brand-navy, #164170);
}

.sitLoginHero > img {
  display: block;
  width: 52px;
  height: 52px;
  margin-bottom: 26px;
  object-fit: contain;
}

.sitLoginHero h2 {
  margin: 0;
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 24px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0;
}

.sitLoginHero p {
  margin: 10px 0 26px;
  color: var(--text-body, #334155);
  font-size: 14px;
  line-height: 1.5;
}

.sitLoginHero__points {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 2px;
}

.sitLoginHero__points > div {
  display: flex;
  align-items: flex-start;
}

.sitLoginHero__points strong {
  display: block;
  font-size: 13.5px;
  font-weight: 700;
}

.sitLoginHero__points em {
  display: block;
  margin-top: 1px;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  font-style: normal;
  line-height: 1.35;
}

.sitLoginFormPane {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 40px 40px 34px;
}

.sitLoginForm {
  width: 100%;
  max-width: 340px;
  margin: 0 auto;
}

.sitLoginForm h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 25px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0;
}

.sitLoginForm > p {
  margin: 6px 0 24px;
  color: var(--text-muted, #64748b);
  font-size: 14px;
}

.sitLoginForm a {
  color: var(--brand-600, #227ebd);
  font-weight: 600;
  text-decoration: none;
}

.sitLoginForm a:hover {
  text-decoration: underline;
}

.sitLoginError {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding: 11px 14px;
  border: 1px solid var(--red-200, #f4c4c9);
  border-radius: var(--radius-md, 10px);
  background: var(--red-50, #fdeef0);
  color: var(--red-700, #b23140);
  font-size: 13px;
  font-weight: 600;
}

.sitLoginError svg {
  flex: 0 0 auto;
}

.sitLoginField {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0 0 14px;
}

.sitLoginField > span {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  color: var(--text-body, #334155);
  font-size: 12.5px;
  font-weight: 650;
}

.sitLoginField > span a {
  font-size: 12.5px;
}

.sitLoginField > div {
  position: relative;
}

.sitLoginField > div > svg {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted, #64748b);
  pointer-events: none;
}

.sitLoginField input[type='email'],
.sitLoginField input[type='password'],
.sitLoginField input[type='text'] {
  width: 100%;
  height: 46px;
  box-sizing: border-box;
  padding: 0 44px 0 42px;
  border: 1px solid var(--border-default, #d3dae2);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font: inherit;
  font-size: 14.5px;
  outline: none;
  transition: border-color 0.12s ease, box-shadow 0.12s ease;
}

.sitLoginField input::placeholder {
  color: var(--text-subtle, #94a3b8);
}

.sitLoginField input:focus {
  border-color: var(--brand-400, #7db4e0);
  box-shadow: 0 0 0 3px var(--brand-100, #d8e8f6);
}

.sitLoginField--error input[type='email'],
.sitLoginField--error input[type='password'],
.sitLoginField--error input[type='text'] {
  border-color: var(--red-500, #da4453);
}

.sitLoginField button {
  position: absolute;
  right: 8px;
  top: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #64748b);
  cursor: pointer;
  transform: translateY(-50%);
}

.sitLoginField button:hover {
  background: var(--surface-hover, #f8fafc);
  color: var(--text-body, #334155);
}

.sitLoginRemember {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin: 2px 0 20px;
  color: var(--text-body, #334155);
  font-size: 13.5px;
  font-weight: 500;
  cursor: pointer;
}

.sitLoginRemember input {
  width: 16px;
  height: 16px;
  accent-color: var(--brand-600, #227ebd);
}

.sitLoginSubmit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 46px;
  border: 1px solid var(--brand-600, #227ebd);
  border-radius: var(--radius-md, 10px);
  background: var(--brand-600, #227ebd);
  color: #fff;
  font: inherit;
  font-size: 14px;
  font-weight: 750;
  cursor: pointer;
}

.sitLoginSubmit:hover {
  background: var(--brand-700, #1c6ba3);
}

.sitLoginSecurity {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

.sitLoginSecurity svg {
  color: var(--text-subtle, #94a3b8);
  flex: 0 0 auto;
}

@media (max-width: 760px) {
  .sitLoginPage {
    align-items: stretch;
    padding: 16px;
  }

  .sitLoginCard {
    min-height: 0;
    flex-direction: column;
  }

  .sitLoginHero {
    flex: 0 0 auto;
    padding: 26px 24px;
  }

  .sitLoginHero__points {
    display: none;
  }

  .sitLoginFormPane {
    padding: 28px 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LoginForm/LoginForm.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,8FAA8F;AAChG;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,0EAA0E;EAC1E,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,qCAAqC;EACrC,kCAAkC;EAClC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,gDAAgD;EAChD,qCAAqC;EACrC,qCAAqC;EACrC,kCAAkC;EAClC,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,qCAAqC;EACrC,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;EACnD,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;IACpB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".sitLoginPage {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n\n.sitLoginCard {\n  width: 100%;\n  max-width: 860px;\n  min-height: 460px;\n  display: flex;\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-xl, 18px);\n  background: var(--surface-card, #fff);\n  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);\n}\n\n.sitLoginHero {\n  flex: 0 0 350px;\n  display: flex;\n  flex-direction: column;\n  padding: 40px 34px;\n  background: linear-gradient(155deg, #eef6fc 0%, #dceef9 58%, #cfe8f5 100%);\n  color: var(--brand-navy, #164170);\n}\n\n.sitLoginHero > img {\n  display: block;\n  width: 52px;\n  height: 52px;\n  margin-bottom: 26px;\n  object-fit: contain;\n}\n\n.sitLoginHero h2 {\n  margin: 0;\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.sitLoginHero p {\n  margin: 10px 0 26px;\n  color: var(--text-body, #334155);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.sitLoginHero__points {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  margin-top: 2px;\n}\n\n.sitLoginHero__points > div {\n  display: flex;\n  align-items: flex-start;\n}\n\n.sitLoginHero__points strong {\n  display: block;\n  font-size: 13.5px;\n  font-weight: 700;\n}\n\n.sitLoginHero__points em {\n  display: block;\n  margin-top: 1px;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  font-style: normal;\n  line-height: 1.35;\n}\n\n.sitLoginFormPane {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  padding: 40px 40px 34px;\n}\n\n.sitLoginForm {\n  width: 100%;\n  max-width: 340px;\n  margin: 0 auto;\n}\n\n.sitLoginForm h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 25px;\n  line-height: 1.2;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.sitLoginForm > p {\n  margin: 6px 0 24px;\n  color: var(--text-muted, #64748b);\n  font-size: 14px;\n}\n\n.sitLoginForm a {\n  color: var(--brand-600, #227ebd);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.sitLoginForm a:hover {\n  text-decoration: underline;\n}\n\n.sitLoginError {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  padding: 11px 14px;\n  border: 1px solid var(--red-200, #f4c4c9);\n  border-radius: var(--radius-md, 10px);\n  background: var(--red-50, #fdeef0);\n  color: var(--red-700, #b23140);\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.sitLoginError svg {\n  flex: 0 0 auto;\n}\n\n.sitLoginField {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0 0 14px;\n}\n\n.sitLoginField > span {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  color: var(--text-body, #334155);\n  font-size: 12.5px;\n  font-weight: 650;\n}\n\n.sitLoginField > span a {\n  font-size: 12.5px;\n}\n\n.sitLoginField > div {\n  position: relative;\n}\n\n.sitLoginField > div > svg {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted, #64748b);\n  pointer-events: none;\n}\n\n.sitLoginField input[type='email'],\n.sitLoginField input[type='password'],\n.sitLoginField input[type='text'] {\n  width: 100%;\n  height: 46px;\n  box-sizing: border-box;\n  padding: 0 44px 0 42px;\n  border: 1px solid var(--border-default, #d3dae2);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font: inherit;\n  font-size: 14.5px;\n  outline: none;\n  transition: border-color 0.12s ease, box-shadow 0.12s ease;\n}\n\n.sitLoginField input::placeholder {\n  color: var(--text-subtle, #94a3b8);\n}\n\n.sitLoginField input:focus {\n  border-color: var(--brand-400, #7db4e0);\n  box-shadow: 0 0 0 3px var(--brand-100, #d8e8f6);\n}\n\n.sitLoginField--error input[type='email'],\n.sitLoginField--error input[type='password'],\n.sitLoginField--error input[type='text'] {\n  border-color: var(--red-500, #da4453);\n}\n\n.sitLoginField button {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n  transform: translateY(-50%);\n}\n\n.sitLoginField button:hover {\n  background: var(--surface-hover, #f8fafc);\n  color: var(--text-body, #334155);\n}\n\n.sitLoginRemember {\n  display: inline-flex;\n  align-items: center;\n  gap: 9px;\n  margin: 2px 0 20px;\n  color: var(--text-body, #334155);\n  font-size: 13.5px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.sitLoginRemember input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--brand-600, #227ebd);\n}\n\n.sitLoginSubmit {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 46px;\n  border: 1px solid var(--brand-600, #227ebd);\n  border-radius: var(--radius-md, 10px);\n  background: var(--brand-600, #227ebd);\n  color: #fff;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.sitLoginSubmit:hover {\n  background: var(--brand-700, #1c6ba3);\n}\n\n.sitLoginSecurity {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 22px;\n  padding-top: 18px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n.sitLoginSecurity svg {\n  color: var(--text-subtle, #94a3b8);\n  flex: 0 0 auto;\n}\n\n@media (max-width: 760px) {\n  .sitLoginPage {\n    align-items: stretch;\n    padding: 16px;\n  }\n\n  .sitLoginCard {\n    min-height: 0;\n    flex-direction: column;\n  }\n\n  .sitLoginHero {\n    flex: 0 0 auto;\n    padding: 26px 24px;\n  }\n\n  .sitLoginHero__points {\n    display: none;\n  }\n\n  .sitLoginFormPane {\n    padding: 28px 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
